// extracted by mini-css-extract-plugin
export default {"root":"-h_Km","label":"zIvZj"};